import * as Immutable from 'seamless-immutable';
import { Action } from 'redux';
import { isType } from 'typescript-fsa/lib';
import { updateCategoryEntities } from './categories.actions';
import { AppState } from '../../reducers';
import * as R from 'ramda';

export interface SupportedFilter {
  id: string;
  name: string;
  additional: boolean;
  uniqueId: number;
}

export interface Category {
  id: number;
  name: string;
  normalized: string;
  parent_id?: number;
  parents: number[];
  sub_categories?: number[];
  isGender: boolean;
  supportedFilters?: SupportedFilter[];
  categorySearchImage?: string;
  gender?: string;
  attributes: CategoryAttributes;
  topCategoryLabel?: string;
  parentCategoryNames: string[];
}

interface CategoryAttributes {
  sale?: boolean;
}

export interface Categories {
  [key: number]: {
    byId: {
      [key: string]: Category;
    };
  };
}

const initialState = Immutable.from<Categories>({});

export type CategoryState = Categories & Immutable.ImmutableObject<Categories>;

export default function reduce(
  state: CategoryState = initialState,
  action: Action
) {
  if (isType(action, updateCategoryEntities)) {
    const {
      payload: { appId, categories },
    } = action;
    return state.merge(
      {
        [appId]: {
          byId: categories,
        },
      },
      { deep: true }
    );
  }

  return state;
}

export function getCategoriesByIds(
  state: AppState,
  appId: number,
  ids: number[]
): Category[] {
  const {
    entities: { categories },
  } = state;

  return categories[appId] && ids.map(id => categories[appId].byId[id]);
}

export function getCategoryById(state: AppState, appId: number, id: number) {
  const categories = getCategoriesByIds(state, appId, [id]);
  return categories && R.head(categories);
}

export function getCategoriesByAppId(state: AppState, appId: number) {
  const {
    entities: { categories },
  } = state;
  return categories[appId] && R.values(categories[appId].byId);
}

export function getCategoryIdsByAppId(state: AppState, appId: number) {
  const categoriesByAppIdLens = R.lensPath([
    'entities',
    'categories',
    appId,
    'byId',
  ]);

  return R.keys(R.view(categoriesByAppIdLens, state)) || [];
}

export function getSubCategoryIds(
  state: AppState,
  appId: number,
  categoryId: number
) {
  const category = getCategoryById(state, appId, categoryId);
  const directSubCategoryIds = (category && category.sub_categories) || [];

  if (!directSubCategoryIds.length) {
    return [categoryId];
  }

  const allSubCategoryIds = directSubCategoryIds.reduce(
    (acc, cur) => [...acc, ...getSubCategoryIds(state, appId, cur)],
    []
  );

  return [categoryId, ...allSubCategoryIds];
}



// WEBPACK FOOTER //
// ./src/store/Entities/Categories/categories.reducer.ts